module.exports = __webpack_public_path__ + "img/posAnalytics.0d1b3eea.png";